import { render, staticRenderFns } from "./TransferenciaEAproveitamento.vue?vue&type=template&id=cfa5e5d2&scoped=true&lang=pug&"
import script from "./TransferenciaEAproveitamento.vue?vue&type=script&lang=js&"
export * from "./TransferenciaEAproveitamento.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciaEAproveitamento.styl?vue&type=style&index=0&id=cfa5e5d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa5e5d2",
  null
  
)

export default component.exports